import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo7/mariaderechos.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import { modulo7 } from "../../../routes/Module7";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo7/Actividad 7.mp3";

const Actividad7 = () => {
  const infoUnidad = modulo7.content[0];
  const infoAct = modulo7.content[0].activities[6];
  const crumbs = [
    {
      title: modulo7.title,
      url: "/" + modulo7.url,
    },
    {
      title:
        modulo7.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo7.content[0].activities[7].name}`,
    linkNext: `${modulo7.url}/${modulo7.content[0].path}/${modulo7.content[0].activities[7].path}`,
    titlePrev: `${modulo7.content[0].activities[5].name}`,
    linkPrev: `${modulo7.url}/${modulo7.content[0].path}/${modulo7.content[0].activities[5].path}`,
  };
  const metadata = {
    color: modulo7.color,
    title: `${modulo7.title} - ${infoAct.name}`,
    name: modulo7.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo7.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <ul>
        <li>Observa esta escena entre María y su mamá.</li>
      </ul>
      <div className="row mt-5 align-items-center">
        <div className="col-md-10 offset-md-1 col-xs-12 text-center">
          <img src={Imagen1} alt="escudo" className="img-fluid mt-2" />
        </div>
      </div>
      <ul className="mt-5">
        <li>Ahora conversa con un compañero, compañera o familiar.</li>
      </ul>
      <div className="ms-3">
        <p>
          ¿Cuál es el problema que observan en la escena? ¿Qué quiere María?
          ¿Qué quiere su mamá?
        </p>
        <textarea className="form-control mb-4" rows={3} />
        <p>¿Cuál de las dos tiene razón?</p>
        <textarea className="form-control mb-4" rows={3} />
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones y la historieta. Oriente la descripción de lo que
          ocurre: María apela a un derecho y su mamá a un deber. Las dos tienen
          razón, pero hay momentos para cada cosa.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad7;
